import _ from 'lodash';
import {useState} from 'react';
import {useNavigate} from 'react-router-dom';
import {Button, Layout, Row, Typography} from 'antd';
import {MenuOutlined, PlusOutlined, ReloadOutlined} from '@ant-design/icons';

import {Header} from 'pm-components';

import {SideMenu} from '../SideMenu';
import {useGetRecurringExpensesQuery} from './api';
import {RecurringExpense} from './RecurringExpense';

const {Content} = Layout;
const {Text} = Typography;

export function RecurringExpenseList() {
    const [menuCollapsed, setMenuCollapsed] = useState(true)

    const {data: recurringExpenses, refetch} = useGetRecurringExpensesQuery({});

    const navigate = useNavigate();

    return (
        <>
            <Header
                leftIcon={<MenuOutlined/>}
                onLeftClick={() => setMenuCollapsed(!menuCollapsed)}
                rightIcon={<ReloadOutlined/>}
                onRightClick={refetch}
            >
                <Text className={'h2'}>Recurring Expenses</Text>
            </Header>

            <SideMenu menuCollapsed={menuCollapsed}/>

            <Content onClick={() => setMenuCollapsed(true)}>
                <Row className={'mb-80'}>
                    {_.map(recurringExpenses, (recurringExpense) => {
                        return <RecurringExpense item={recurringExpense} key={recurringExpense.id}/>
                    })}
                </Row>

                <Button
                    className={'floating-btn floating-btn--right floating-btn--xl'}
                    type={'primary'}
                    shape={'circle'}
                    size={'large'}
                    icon={<PlusOutlined/>}
                    onClick={() => {navigate('new')}}
                />
            </Content>
        </>
    )
}
